import { Routes, Route } from 'react-router-dom'

import Roulette from '~/pages/Roulette'

const Router = () => (
  <Routes>
    <Route path="/:campaignSlug/:contractNumber" element={<Roulette />} />
    <Route path="/:campaignSlug" element={<Roulette />} />
  </Routes>
)

export default Router
